<template>
    <ValidationProvider v-slot="{ errors }" name="LimeIq Key" rules="required">
      <AdvancedDropdown
        v-model="modelValue"
        v-bind="$attrs"
        :options="bdxKeyOptions"
        :disabled="false"
        :can-add-new="false"
        label="LimeIq Key"
        size="sm"
        :loading="loading"
      >
        <template v-slot:label> LimeIQ Bdx Key <span class="text-danger">*</span> </template>
  
        <template v-slot:button-content>
          <template v-if="!!selectedBdxKey">{{ selectedBdxKey.text }}</template>
          <template v-else>Select</template>
        </template> 

      </AdvancedDropdown>
  
      <div v-if="!!errors.length" class="invalid-feedback d-block">
        {{ errors[0] }}
      </div>
    </ValidationProvider>
  </template>
  
  <script>
import Vue from 'vue'
import { ValidationProvider } from 'vee-validate'
import { BaseIcon } from '@components/base'
import { AdvancedDropdown } from '@components/advanced'
import { userMixin } from '@mixins'
import CashCallService from '../../services/CashCallService'


export default {
  name: 'CashCallFormBdxList',
  components: { ValidationProvider, BaseIcon, AdvancedDropdown },
  mixins: [userMixin],
  props: {
    // must stay as Array, since AdvancedDropdown expects Array
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bdxKeyOptions: [],
      loading: false, 
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
        const val = newValue && newValue[0] || null
        this.$emit('update:selectedBdxKey', val)
      }
    },

    selectedBdxKey() {
      const val = this.value && this.value[0]
      if (!val) return null
      return this.bdxKeyOptions.find(opt => opt.value === val) || null
    }
  },
  methods: {
    // 'All', not 'Active': a cash call can be raised on an Inactive LimeIQ Key,
    // which the save then reactivates (LIQ-1198). With 'Active' the key - and
    // its claim refs - never reached this dropdown, so the standard flow could
    // not select it at all. The co-lead search already lists every key.
    async getParameters(params = null, flags = null, umrCriteria = 'All') {
      this.loading = true;
      const data = {
        company_id: this.userCompanyId,
        role: this.userCompanyRole,
        role_value: this.userCompanyRoleValue,
        umr_criteria: umrCriteria,
        uw_option: 'Lead'
      }

      try {
        const response = await CashCallService.getBdxKeys(data)
        const parameters = response.data.data.data
        const uniqueBdxKeys = [...new Set(parameters.UMR_Risk_Cat_Section)]
        console.log("BDX key count:", uniqueBdxKeys.length)
        this.bdxKeyOptions = uniqueBdxKeys.map(key => ({
          text: key,
          value: key
        }))
        const claimReferences = parameters.Claim_Reference
        if(claimReferences !== null && claimReferences !== undefined && claimReferences.length > 0) {
          console.log('claim references exists')
          this.$emit('update:claimReferences', claimReferences)         
        }
        Vue.prototype.$emitter.emit('claims-loaded', {
          status: true
        })
        this.loading = false
      } catch (err) {
        console.error('Error fetching UMRs', err)
        this.loading = false
      }
    }
  },
  mounted() {
    this.getParameters()
  }
}
</script>


  
  <style scoped>
  .advanced-dropdown >>> .dropdown-toggle {
    max-width: 350px;
    font-size:12px;
  }
  
  .advanced-dropdown >>> .dropdown-menu .list-group-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .advanced-dropdown >>> .dropdown-menu .list-group-item.disabled {
    color: #fff;
    background-color: #1c4a50;
    pointer-events: initial;
  }
  </style>
  